import React from 'react';
import { TableCell, TableHead, TableRow } from '@fuww/library/src/Table';
import { useIntl } from 'react-intl';
import messages from '../../lib/messages.mjs';

const FashionIndexTableHead = ({ alignRight }: { alignRight?: boolean }) => {
  const intl = useIntl();

  return (
    <TableHead>
      <TableRow>
        <TableCell width="10%">#</TableCell>
        <TableCell width="70%">{intl.formatMessage(messages.brand)}</TableCell>
        <TableCell width="20%" align={alignRight ? 'right' : 'left'}>
          {intl.formatMessage(messages.followers)}
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export default FashionIndexTableHead;
